import { SVG_AddPair } from "./SVG_AddPair";

export function SVG_PathFromRect(clipRect) {
  var pStr = SVG_AddPair("M", clipRect.fLeft, clipRect.fTop);
  pStr += SVG_AddPair("L", clipRect.fRight, clipRect.fTop);
  pStr += SVG_AddPair("L", clipRect.fRight, clipRect.fBottom);
  pStr += SVG_AddPair("L", clipRect.fLeft, clipRect.fBottom);
  pStr += SVG_AddPair("L", clipRect.fLeft, clipRect.fTop);
  pStr += "Z";

  return pStr;
}
